import { gql } from "@apollo/client";

export const CREATE_GRAPHIC_STAND = gql`
  mutation GraphicStandCreate($input: GraphicStandFieldsInput!) {
    graphicStandCreate(input: $input) {
      label
      message
      graphicStand {
        id
        exhibitor
        graphic_list_id
        stand_id
        hall_name
        block
        corridor
        comment
        stand_number
        status
        complete_at
        relStand {
          id
          shelf_number
        }
        relPackedUser {
          id
          name
          surname
        }
      }
    }
  }
`;

export const UPDATE_GRAPHIC_STAND = gql`
  mutation GraphicStandUpdate($input: GraphicStandFieldsInput!) {
    graphicStandUpdate(input: $input) {
      label
      message
      graphicStand {
        id
        exhibitor
        graphic_list_id
        stand_id
        hall_name
        block
        corridor
        comment
        stand_number
        status
        complete_at
        relStand {
          id
          shelf_number
        }
        relPackedUser {
          id
          name
          surname
        }
      }
    }
  }
`;

export const DELETE_GRAPHIC_STAND = gql`
  mutation GraphicStandDelete($id: ID!) {
    graphicStandDelete(id: $id) {
      label
      message
    }
  }
`;

export const EXPORT_EXCEL_GRAPHIC_STAND = gql`
  mutation GraphicListStandExportExel($id: ID!) {
    graphicListStandExportExel(id: $id) {
      label
      message
      file
    }
  }
`;

export const PRINT_LABEL_GRAPHIC_STAND = gql`
  mutation GraphicStandPrintLabel($graphic_stand_id: ID!) {
    graphicStandPrintLabel(graphic_stand_id: $graphic_stand_id) {
      label
      message
      file
    }
  }
`;

export const EXPORT_EXCEL_GRAPHIC_STORED_ALL = gql`
  mutation GraphicStoredAllExportExel {
    graphicStoredAllExportExel {
      label
      message
      file
    }
  }
`;

export const EXPORT_EXCEL_GRAPHIC_STORED_AVAILABLE = gql`
  mutation GraphicStoredAvailableExportExel {
    graphicStoredAvailableExportExel {
      label
      message
      file
    }
  }
`;